// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1WSAE","buttons":"SendReceipts_buttons__miDnK","email":"SendReceipts_email__1T7oo","bookApptTitle":"SendReceipts_bookApptTitle__33_MF"};